module.exports = __webpack_public_path__ + "img/hero-m.2035856d.webp";